import React, { FC } from "react";

import { FeatureCardChip, FeatureCardChipsContainer } from "../../styled";

export const FeatureCardChips: FC<{ tags?: string[]; bgColor?: string; fontColor?: string; fontSize?: string }> = ({
  tags,
  bgColor,
  fontColor,
  fontSize,
}) => (
  <FeatureCardChipsContainer>
    {tags?.map(tag => (
      <FeatureCardChip key={tag} text={tag} $bgColor={bgColor} $fontColor={fontColor} $fontSize={fontSize} $isDefault />
    ))}
  </FeatureCardChipsContainer>
);
